import { DestroyService } from './destroy.service';
import { MatchMediaService } from './match-media.service';

export { DestroyService, MatchMediaService };
